import {
  buildOptionalParams,
  buildPath,
  buildTemplatePath,
  CrudMode,
  Dialog,
  handleClose,
  PageRoute,
  useParams,
  useUnsavedChanges,
  useValidationErrors,
} from "@compass/core";
import { Permission, SuppliesDetail, SuppliesDetailViewResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "services/apiService";
import { SuppliesDetailPageBody } from "./SuppliesDetailPageBody";
import { SuppliesDetailPageHeader } from "./SuppliesDetailPageHeader";

const routeName = "suppliesDetail";

class Params {
  id: number = 0;
  crudMode: CrudMode = "view";
}

export const suppliesDetailPageRoute: PageRoute<Params> = {
  handle: "Supplies Details",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
};

export const SuppliesDetailPage = () => {
  const ROOT_PERMISSION: Permission = Permission.SystemUtility;
  const navigate = useNavigate();
  const { params } = useParams(routeName, Params);
  const [suppliesDetail, setSuppliesDetail] = useState<SuppliesDetail>({} as SuppliesDetail);
  const [initSuppliesDetail, setInitSuppliesDetail] = useState<SuppliesDetail>(suppliesDetail);
  const [viewResource, setViewResource] = useState<SuppliesDetailViewResource>({});
  const { unsavedChanges, resetUnsavedChanges } = useUnsavedChanges({ trackedItems: [suppliesDetail] });
  const { validationErrors, setValidationErrors } = useValidationErrors();

  useEffect(() => {
    fetch(params.id);

    ApiService.suppliesDetails.getViewResource().then((response) => {
      setViewResource(response);
    });
  }, []);

  const reroute = (id: number, crudMode: CrudMode) =>
    navigate(`../${suppliesDetailPageRoute.getPath({ id: id, crudMode: crudMode })}`);

  const fetch = (id: number) => {
    ApiService.suppliesDetails.get(id).then((response) => {
      setSuppliesDetail(response);
      setInitSuppliesDetail(response);
      resetUnsavedChanges([response]);
    });
  };

  return (
    <Dialog
      isForm
      open={true}
      onClose={() => handleClose(navigate, unsavedChanges)}
      maxWidth="sm"
      header={
        <SuppliesDetailPageHeader
          rootPermission={ROOT_PERMISSION}
          handle={suppliesDetailPageRoute.handle}
          crudMode={params.crudMode}
          reroute={reroute}
          fetch={fetch}
          suppliesDetail={suppliesDetail}
          setSuppliesDetail={setSuppliesDetail}
          initSuppliesDetail={initSuppliesDetail}
          setValidationErrors={setValidationErrors}
          unsavedChanges={unsavedChanges}
          resetUnsavedChanges={resetUnsavedChanges}
        />
      }
      content={
        <SuppliesDetailPageBody
          suppliesDetail={suppliesDetail}
          setSuppliesDetail={setSuppliesDetail}
          viewResource={viewResource}
          crudMode={params.crudMode}
          validationErrors={validationErrors}
        />
      }
    />
  );
};
